'use strict';

module.exports = function (value) {
    var data = {
        value: value
    };

    return function (value) {
        if (!arguments.length) return data.value;

        data.value = value;

        return value;
    };
};